<template>
  <div class="card-header card-footer">
    <div class="row justify-content-start align-items-center">
      <div class="col-sm-auto col-4">
        <material-avatar
        img=""
        :alt="name"
        size="xl"
        :color="user.color"
        shadow="sm"
        circular
        />
      </div>
      <div class="col-sm-auto col-8 my-auto">
        <div class="h-100">
          <h5 class="mb-1 font-weight-bolder">{{ name }}</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MaterialAvatar from "@/components/ui/MaterialAvatar.vue";
import { mapState } from "vuex";

export default {
  name: "ProfileHeader",
  components: {
    MaterialAvatar
  },
  computed: {
    ...mapState("user", ["user"]),
    name() {
      return this.user ? this.user.name : 'Unknown username';
    }
  }
};
</script> 